import { gql } from '@apollo/client'
import { client } from './apollo'
import { GetWxworkAgentConfigSignatureDocument } from './gql/graphql'

gql`
  query GetWxworkAgentConfigSignature($url: String!) {
    wxworkAgentConfigSignature(url: $url) {
      timestamp
      nonceStr
      signature
    }
  }
`

export async function getAgentConfigSignature(url: string) {
  const { data } = await client.query({
    query: GetWxworkAgentConfigSignatureDocument,
    variables: { url },
  })

  if (!data) {
    throw new Error('Failed to get wxwork agent config signature')
  }

  return data.wxworkAgentConfigSignature
}
